import React from 'react';


function NotFound() {
    return (  
        <div className="row text-center my-5">
        <h1 className='fs-2'>
          404 Not Found
        </h1>
        <p>Sorry, the page you are looking for does not exist.</p>
        </div>
    );
}

export default NotFound;